import * as Features from './Features';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
const appUrlBase = getFullUrl('app', {});
const knowledgeUrlBase = 'https://knowledge.hubspot.com';
const hubspotUrlBase = 'https://www.hubspot.com';
const portalId = PortalIdParser.get();
const FeaturesMap = {
  [Features.AD_RETARGETING]: {},
  [Features.LIVE_CHAT]: {
    href: `${appUrlBase}/chatflows/${portalId}`
  },
  [Features.CONVERSATIONAL_BOTS]: {
    href: `${appUrlBase}/chatflows/${portalId}`
  },
  [Features.TEAM_EMAIL]: {},
  [Features.CONVERSATIONS_INBOX]: {},
  [Features.FORMS]: {},
  [Features.AD_MANAGEMENT]: {},
  [Features.GOOGLE_SEARCH_CONSOLE_INTEGRATION]: {},
  [Features.REPORTING_DASHBOARDS]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.TEAMS]: {
    href: `${knowledgeUrlBase}/account/how-can-i-create-a-team-in-hubspot`
  },
  [Features.MOBILE_OPTIMIZATION]: {},
  [Features.PHONE_SUPPORT]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.STANDARD_CONTACT_SCORING]: {
    href: `${knowledgeUrlBase}/crm-setup/set-up-score-properties-to-qualify-leads`
  },
  [Features.ONE_TO_ONE_EMAIL]: {},
  [Features.ALL_CRM_FEATURES]: {},
  [Features.CALLING_SDK]: {},
  [Features.STRIPE_INTEGRATION]: {
    freeUser: 'noAccess'
  },
  [Features.EMAIL_MARKETING]: {},
  [Features.LIST_SEGMENTATION]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.SOCIAL_MEDIA]: {
    href: `${appUrlBase}/social/${portalId}`
  },
  [Features.CALLS_TO_ACTION]: {
    href: `${appUrlBase}/ctas/${portalId}`
  },
  [Features.LANDING_PAGES]: {
    href: `${appUrlBase}/pages/${portalId}`
  },
  [Features.SSL_CERTIFICATE]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.OMNI_CHANNEL_MARKETING_AUTOMATION]: {
    href: `${appUrlBase}/workflows/${portalId}`
  },
  [Features.SALESFORCE_INTEGRATION]: {
    href: `${knowledgeUrlBase}/articles/kcs_article/salesforce/install-the-hubspot-salesforce-integration`
  },
  [Features.SALESFORCE_CUSTOM_OBJECT_SYNC]: {
    href: `${knowledgeUrlBase}/salesforce/set-up-and-use-salesforce-custom-object-sync`
  },
  [Features.WEBSITE_TRAFFIC_ANALYTICS]: {
    href: `${appUrlBase}/analytics/${portalId}`
  },
  [Features.CAMPAIGN_REPORTING]: {
    href: `${appUrlBase}/analytics/${portalId}`
  },
  [Features.ATTRIBUTION_REPORTING]: {
    href: `${appUrlBase}/analytics/${portalId}`
  },
  [Features.AB_TESTING]: {
    href: `${knowledgeUrlBase}/articles/kcs_article/email/run-an-a/b-test-on-your-marketing-email`
  },
  [Features.CUSTOM_REPORTS]: {
    href: `${appUrlBase}/reports-list/${portalId}`
  },
  [Features.PREDICTIVE_LEAD_SCORING]: {
    href: `${knowledgeUrlBase}/articles/kcs_article/contacts/determine-likelihood-to-close-with-predictive-lead-scoring`
  },
  [Features.SINGLE_SIGN_ON]: {
    href: `${appUrlBase}/settings/${portalId}/account-defaults/general`
  },
  [Features.PARTITIONING]: {
    href: `${appUrlBase}/pages/${portalId}`
  },
  [Features.FACEBOOK_MESSENGER]: {},
  [Features.YOUTUBE_INTEGRATION]: {},
  [Features.FILTERED_ANALYTICS_VIEW]: {
    href: `${appUrlBase}/analytics/${portalId}`
  },
  [Features.EMAIL_SEND_FREQUENCY_CAP]: {
    href: `${appUrlBase}/settings/${portalId}/marketing/email/frequency`
  },
  [Features.EMAIL_TRACKING_NOTIFICATIONS]: {
    freeUser: 'limitedAccess'
  },
  [Features.EMAIL_SCHEDULING]: {},
  [Features.SNIPPETS]: {
    freeUser: 'limitedAccess'
  },
  [Features.CALLING]: {
    freeUser: 'limitedAccess',
    hideFromLang: ['ja']
  },
  [Features.SEQUENCES]: {
    href: `${appUrlBase}/sequences/${portalId}`,
    freeUser: 'noAccess'
  },
  [Features.MEETINGS]: {
    href: `${appUrlBase}/meetings/${portalId}`,
    freeUser: 'limitedAccess'
  },
  [Features.REP_PRODUCTIVITY_PERFORMANCE]: {
    href: `${appUrlBase}/analytics/${portalId}/sales-productivity/deals`
  },
  [Features.EMAIL_SUPPORT]: {},
  [Features.DEAL_PIPELINE]: {},
  [Features.PRODUCTS]: {
    href: `${appUrlBase}/settings/${portalId}/sales/products`
  },
  [Features.SALES_AUTOMATION]: {
    href: `${appUrlBase}/workflows/${portalId}`
  },
  [Features.AUTOMATIC_LEAD_ROTATION]: {
    href: `${appUrlBase}/workflows/${portalId}`,
    freeUser: 'noAccess'
  },
  [Features.REQUIRED_FIELDS]: {
    href: `${knowledgeUrlBase}/crm-setup/set-up-fields-seen-when-manually-creating-records`
  },
  [Features.QUOTES]: {
    href: `${appUrlBase}/quotes/${portalId}`
  },
  [Features.SMART_SEND_TIMES]: {
    href: `${knowledgeUrlBase}/email/schedule-a-one-to-one-email-from-the-crm`
  },
  [Features.PERMISSION_SETS]: {
    href: `${appUrlBase}/settings/${portalId}/users/permissions`
  },
  [Features.MULTI_CURRENCY]: {
    href: `${appUrlBase}/settings/${portalId}/account-defaults/multicurrency`
  },
  [Features.VIDEO_CREATION]: {
    href: `${knowledgeUrlBase}/email/add-videos-to-crm-emails`
  },
  [Features.VIDEO_CREATION_AND_HOSTING]: {},
  [Features.RECURRING_REVENUE_TRACKING]: {
    href: `${knowledgeUrlBase}/articles/kcs_article/deals/track-recurring-revenue-with-revenue-analytics`
  },
  [Features.GOALS]: {
    href: `${appUrlBase}/settings/${portalId}/goals`,
    freeUser: 'noAccess'
  },
  [Features.ESIGN]: {
    href: `${knowledgeUrlBase}/deals/use-e-signatures-with-quotes`,
    freeUser: 'noAccess'
  },
  [Features.WORKFLOWS_EXTENSIONS]: {},
  [Features.CUSTOM_BOTS]: {},
  [Features.SLACK]: {
    href: `${appUrlBase}/ecosystem/${portalId}/marketplace/apps/sales/sales-enablement/slack`
  },
  [Features.VIDEO_HOSTING_MANAGEMENT]: {
    href: `${appUrlBase}/file-manager-beta/${portalId}`
  },
  [Features.PLAYBOOKS]: {
    href: `${appUrlBase}/playbooks/${portalId}`,
    freeUser: 'noAccess'
  },
  [Features.TICKETING]: {},
  [Features.CUSTOMER_SERVICE_AUTOMATION]: {
    href: `${appUrlBase}/workflows/${portalId}/view/all`
  },
  [Features.TEMPLATES]: {
    freeUser: 'limitedAccess'
  },
  [Features.DOCUMENTS]: {
    freeUser: 'limitedAccess'
  },
  [Features.CONVERSATION_ROUTING]: {
    freeUser: 'noAccess'
  },
  [Features.KNOWLEDGE_BASE]: {
    href: `${knowledgeUrlBase}/knowledge-base/how-do-i-create-a-knowledge-base-article`
  },
  [Features.HIERARCHICAL_TEAMS]: {
    href: `${appUrlBase}/settings/${portalId}/users/teams`
  },
  [Features.CONTENT_PARTITIONING]: {
    href: `${knowledgeUrlBase}/account/partition-your-hubspot-assets`
  },
  [Features.ADDITIONAL_ROOT_DOMAINS]: {
    href: `${knowledgeUrlBase}/domains-and-urls/connect-a-domain-to-hubspot`
  },
  [Features.MULTI_DOMAIN_TRAFFIC_REPORTING]: {
    href: `${knowledgeUrlBase}/reports/analyze-your-site-traffic-with-the-traffic-analytics-tool`
  },
  [Features.CALCULATED_PROPERTIES]: {
    href: `${knowledgeUrlBase}/articles/kcs_article/settings/create-calculation-properties`
  },
  [Features.WEBHOOKS]: {
    href: `${knowledgeUrlBase}/articles/kcs_article/workflows/how-do-i-use-webhooks-with-hubspot-workflows`
  },
  [Features.CUSTOM_CODED_BOT_ACTIONS]: {
    href: `https://developers.hubspot.com/docs/api/conversations/code-snippets-in-bots`
  },
  [Features.TICKET_STATUS]: {
    href: `${knowledgeUrlBase}/tickets/automate-ticket-status`
  },
  [Features.TICKET_ROUTING]: {
    href: `${appUrlBase}/workflows/${portalId}`,
    freeUser: 'noAccess'
  },
  [Features.TASK_AUTOMATION]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.MULTIPLE_TICKET_PIPELINES]: {
    href: `${knowledgeUrlBase}/tickets/customize-ticket-pipelines-and-statuses`
  },
  [Features.INSIGHTS_DASHBOARD]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.AGENT_PRESENCE]: {
    freeUser: 'noAccess'
  },
  [Features.HUB_DB_DYNAMIC_CONTENT]: {
    href: `${appUrlBase}/hubdb/${portalId}`
  },
  [Features.WEBSITE_PAGES]: {},
  [Features.DESIGN_MANAGER]: {},
  [Features.STAGING_ENVIRONMENT]: {},
  [Features.WEBSITE_ANALYTICS]: {},
  [Features.CUSTOM_DOMAINS]: {},
  [Features.UPTIME]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.CONTENT_DELIVERY_NETWORK]: {},
  [Features.CONTACT_MANAGEMENT]: {},
  [Features.CONTACT_WEBSITE_ACTIVITY]: {},
  [Features.COMPANIES]: {},
  [Features.DEALS]: {},
  [Features.TASKS_AND_ACTIVITIES]: {},
  [Features.COMPANY_INSIGHTS]: {},
  [Features.GMAIL_AND_OUTLOOK_INTEGRATION]: {},
  [Features.HUBSPOT_CONNECT_INTEGRATIONS]: {},
  [Features.CUSTOM_SUPPORT_FORM_FIELDS]: {},
  [Features.PROSPECTS]: {},
  [Features.MESSENGER_INTEGRATION]: {},
  [Features.CUSTOM_PROPERTIES]: {},
  [Features.TASK_CALENDAR_SYNC]: {
    freeUser: 'noAccess'
  },
  [Features.ACCOUNT_OVERVIEW]: {
    freeUser: 'noAccess'
  },
  [Features.CUSTOM_OBJECTS]: {
    href: `${knowledgeUrlBase}/crm-setup/use-custom-objects`
  },
  [Features.MOBILE_APP]: {},
  [Features.TASK_QUEUES]: {
    freeUser: 'noAccess'
  },
  [Features.SALES_ANALYTICS]: {
    href: `${appUrlBase}/analytics/${portalId}/sales-reports`
  },
  [Features.EMAIL_HEALTH_INSIGHTS]: {},
  [Features.MULTI_LANGUAGE_CONTENT]: {
    href: `${knowledgeUrlBase}/cos-general/how-to-manage-multi-language-content-with-hubspots-cos`
  },
  [Features.LEAD_AND_COMPANY_SCORING]: {
    href: `${knowledgeUrlBase}/crm-setup/set-up-score-properties-to-qualify-leads`
  },
  [Features.ABM_TOOLS_AND_AUTOMATION]: {
    href: `${knowledgeUrlBase}/account/get-started-with-account-based-marketing-in-hubspot`
  },
  [Features.ADS_OPTIMIZATION_EVENTS]: {
    href: `${knowledgeUrlBase}/ads/sync-leads-from-your-google-ads-account-to-hubspot`
  },
  [Features.PROGRAMMABLE_CHATBOTS]: {
    href: `${knowledgeUrlBase}/conversations/a-guide-to-bot-actions#run-a-code-snippet-enterprise-only`
  },
  [Features.BEHAVIORAL_EVENT_TRIGGERS]: {
    href: `${appUrlBase}/analytics/${portalId}/events/manage/events/approved?page=1`
  },
  [Features.EMAIL_COMPARISON_REPORTING]: {},
  [Features.BLOG]: {
    href: `${appUrlBase}/website/${portalId}/blog`
  },
  [Features.SEO_RECOMMEND_OPTIMIZE]: {
    href: `${appUrlBase}/content-strategy/${portalId}/recommendations`
  },
  [Features.SEO_ANALYTICS]: {},
  [Features.CONTENT_STRATEGY]: {
    href: `${knowledgeUrlBase}/seo/create-topics-for-your-seo-strategy`
  },
  [Features.GOOGLE_SEARCH_CONSOLE_INTEGRATION]: {
    href: `${knowledgeUrlBase}/content-strategy/enable-the-google-search-console-integration-for-your-content-strategy-tool`
  },
  [Features.CONTENT_STAGING]: {
    href: `${knowledgeUrlBase}/website-pages/redesign-and-relaunch-your-site-with-content-staging`
  },
  [Features.SMART_CONTENT_AND_REPORTING]: {
    href: `${knowledgeUrlBase}/website-pages/create-and-manage-smart-content-rules`
  },
  [Features.DYNAMIC_PERSONALIZATION]: {
    href: `https://developers.hubspot.com/docs/cms/data/dynamic-pages`
  },
  [Features.PERSONALIZATION_TOKENS]: {
    href: `https://knowledge.hubspot.com/website-pages/personalize-your-content`
  },
  [Features.PASSWORD_PROTECTED_PAGES]: {
    href: `${knowledgeUrlBase}/website-pages/redesign-and-relaunch-your-site-with-content-staging`
  },
  [Features.CONTENT_STRATEGY]: {
    href: 'https://knowledge.hubspot.com/seo/create-topics-for-your-seo-strategy'
  },
  [Features.GOOGLE_SEARCH_CONSOLE_INTEGRATION]: {
    href: 'https://knowledge.hubspot.com/content-strategy/enable-the-google-search-console-integration-for-your-content-strategy-tool'
  },
  [Features.CONTENT_STAGING]: {
    href: 'https://knowledge.hubspot.com/website-pages/redesign-and-relaunch-your-site-with-content-staging'
  },
  [Features.SMART_CONTENT_AND_REPORTING]: {
    href: 'https://knowledge.hubspot.com/website-pages/create-and-manage-smart-content-rules'
  },
  [Features.DYNAMIC_PERSONALIZATION]: {
    href: 'https://developers.hubspot.com/docs/cms/data/dynamic-pages'
  },
  [Features.PASSWORD_PROTECTED_PAGES]: {
    href: 'https://knowledge.hubspot.com/website-pages/redesign-and-relaunch-your-site-with-content-staging'
  },
  [Features.COMPANY_SCORING]: {
    href: `${knowledgeUrlBase}/crm-setup/set-up-score-properties-to-qualify-leads`
  },
  [Features.DRAG_AND_DROP_EDITOR]: {
    href: `${knowledgeUrlBase}/cms-general/create-and-edit-pages-with-the-drag-and-drop-editor`
  },
  [Features.WEBSITE_THEMES]: {
    href: `${knowledgeUrlBase}/website-pages/create-website-content-using-a-theme`
  },
  [Features.MULTI_LANGUAGE_CREATION_TESTING]: {
    href: `${knowledgeUrlBase}/cos-general/how-to-manage-multi-language-content-with-hubspots-cos`
  },
  [Features.LOCAL_WEBSITE_DEVELOPMENT]: {
    href: 'https://designers.hubspot.com/tutorials/getting-started-with-local-development'
  },
  [Features.CONTACT_ATTRIBUTION_REPORT_BUILDER]: {
    href: `${knowledgeUrlBase}/reports/create-custom-contact-attribution-reports`
  },
  [Features.CDN]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.TWENTY_FOUR_SEVEN_SECURITY_MONITORING]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.WEB_APPS]: {
    href: `${hubspotUrlBase}/products/cms/serverless-functions`
  },
  [Features.REVERSE_PROXY_CONFIGURATION]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.MEMBERSHIPS]: {
    href: `${knowledgeUrlBase}/cms-pages-editor/control-audience-access-to-pages`
  },
  [Features.ACTIVITY_LOGGING]: {
    href: `${hubspotUrlBase}/products/cms/activity-logs`
  },
  [Features.CUSTOM_DOMAIN_SECURITY_SETTINGS]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.SITE_PERFORMANCE_MONITORING]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.CODE_ALERTS]: {
    href: `${hubspotUrlBase}/products/cms/website-monitoring`
  },
  [Features.ADDITIONAL_BRAND_DOMAIN]: {
    href: `${hubspotUrlBase}/products/brand-domains`
  },
  [Features.ADAPTIVE_TESTING]: {
    href: `${knowledgeUrlBase}/cms-general/create-an-adaptive-test-for-a-page`
  },
  [Features.FIELD_LEVEL_PERMISSIONS]: {
    href: `${knowledgeUrlBase}/account/restrict-edit-access-for-properties`
  },
  [Features.ADVANCED_PERMISSIONS]: {
    href: `${knowledgeUrlBase}/settings/hubspot-user-permissions-guide`
  },
  [Features.RECORD_CUSTOMIZATION]: {
    href: `${knowledgeUrlBase}/crm-setup/customize-record-sidebars`
  },
  [Features.MULTI_TOUCH_REVENUE_ATTRIBUTION]: {
    href: `${appUrlBase}/report-builder/${portalId}?builderType=builderType__ATTRIBUTION`
  },
  [Features.LOGGED_IN_VISITOR_IDENTIFICATION]: {},
  [Features.MULTI_LANGUAGE_KNOWLEDGE_BASE]: {},
  [Features.KNOWLEDGE_BASE_SINGLE_SIGN_ON]: {},
  [Features.FORECASTING]: {
    href: `${appUrlBase}/forecasting/${portalId}/teams`,
    freeUser: 'noAccess'
  },
  [Features.CUSTOM_BEHAVIORAL_EVENTS]: {},
  [Features.CONVERSATION_INTELLIGENCE]: {
    freeUser: 'noAccess',
    href: `${knowledgeUrlBase}/calling/review-calls`
  },
  [Features.ADMIN_NOTIFICATIONS_MANAGEMENT]: {},
  [Features.SITE_TREE]: {},
  [Features.COLLABORATION_TOOLS]: {
    href: `${appUrlBase}/marketing/${portalId}/tasks`
  },
  [Features.MARKETING_EVENTS_OBJECT]: {},
  [Features.HUBDB]: {},
  [Features.EMAIL_REPLY_TRACKING]: {},
  [Features.EMAIL_HEALTH_REPORTING]: {},
  [Features.CAMPAIGN_MANAGEMENT]: {
    href: `${appUrlBase}/marketing/${portalId}/campaigns`
  },
  [Features.TECHNICAL_SUPPORT]: {},
  [Features.CUSTOM_SURVEYS]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.SANDBOXES]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.DATASETS]: {},
  [Features.ADVANCED_DATA_CALCULATIONS]: {},
  [Features.SNOWFLAKE_DATA_SHARE]: {},
  [Features.CHANNEL_SWITCHING]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.USER_MANAGEMENT]: {},
  [Features.CUSTOM_USER_PERMISSIONS]: {},
  [Features.LOGIN_AS_ANOTHER_USER]: {},
  [Features.PAYMENTS]: {},
  [Features.SCHEDULED_WORKFLOW_TRIGGERS]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.CUSTOMER_PORTAL]: {
    href: `${appUrlBase}/settings/${portalId}/customer-portal/general`
  },
  [Features.POST_CHAT_FEEDBACK]: {},
  [Features.MOBILE_INBOX]: {},
  [Features.CUSTOM_VIEWS_SHARED_INBOX]: {},
  [Features.SLAS]: {
    freeUser: 'noAccess',
    href: `${appUrlBase}/live-messages-settings/${portalId}/inbox/sla`
  },
  [Features.SERVICE_ANALYTICS]: {
    href: `${appUrlBase}/reports-list/${portalId}`
  },
  [Features.SIMPLE_AUTOMATION]: {},
  [Features.SIMPLE_TICKET_AUTOMATION]: {},
  [Features.BUILT_IN_AMP_SUPPORT]: {},
  [Features.ADVANCED_MENUS]: {},
  [Features.APP_AND_ASSET_MARKETPLACE]: {},
  [Features.SUBDOMAIN_AND_COUNTRY_CODE_TLD]: {},
  [Features.SITE_EXPORT]: {},
  [Features.BLOG_IMPORT]: {},
  [Features.URL_MAPPINGS]: {},
  [Features.TARGET_ACCOUNTS_HOME]: {},
  [Features.CUSTOM_FIELD_MAPPINGS]: {},
  [Features.DATA_QUALITY_AUTOMATION]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.PROGRAMMABLE_AUTOMATION]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.DUPLICATE_MANAGEMENT]: {},
  [Features.BULK_DUPLICATE_MANAGEMENT]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.DATA_SYNC]: {},
  [Features.HISTORICAL_SYNC]: {},
  [Features.DEFAULT_FIELD_MAPPINGS]: {},
  [Features.APP_MARKETPLACE_INTEGRATIONS]: {},
  [Features.PREMIUM_HOSTING]: {},
  [Features.WEB_APPLICATION_FIREWALL]: {},
  [Features.WEBSITE_STRUCTURE_IMPORT]: {},
  [Features.CUSTOMER_FEEDBACK_SURVEYS]: {
    href: `${appUrlBase}/feedback/${portalId}`
  },
  [Features.ASSOCIATION_LABELS]: {},
  [Features.HS_PHONE_NUMBERS]: {},
  [Features.CALL_TRANSCRIPTION_AND_COACHING]: {},
  [Features.EMAIL_AUTOMATION]: {},
  [Features.FORM_AUTOMATION]: {},
  [Features.BLOG_EXPORT]: {},
  [Features.AUTO_GENERATED_XML_SITEMAP]: {},
  [Features.APEX_HOSTING_AND_REDIRECTS]: {},
  [Features.CUSTOM_GOALS]: {},
  [Features.DATA_QUALITY_COMMAND_CENTER]: {
    href: `${appUrlBase}/data-quality/${portalId}`
  },
  [Features.DATA_HEALTH_TRENDS]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.AI_POWERED_DATA_FORMATTING_RECOMMENDATIONS]: {
    shouldLinkToFeatureInTrial: false
  },
  [Features.WHATS_APP_INTEGRATION]: {},
  [Features.SALES_CONTENT_ANALYTICS]: {},
  [Features.PRESETS]: {},
  [Features.CUSTOMER_JOURNEY_ANALYTICS]: {},
  [Features.DEAL_SPLITS]: {},
  [Features.CAPACITY_LIMITS_FOR_LIVE_CHAT]: {}
};
Object.keys(FeaturesMap).forEach(feature => {
  if (FeaturesMap[feature].shouldLinkToFeatureInTrial !== false) {
    FeaturesMap[feature].shouldLinkToFeatureInTrial = true;
  }
});
export default FeaturesMap;